import type { Resource } from '../../';
export const product_group_boys: Resource = {"default":"Boys'"};
